import { useNavigate, useSearchParams } from 'react-router-dom';
import { ASSETS } from '../../const/assets';
import { useNews } from '../../hooks/useNews';
import { CircularProgress } from '@mui/material';
function NewsScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role');
  const isNewsLatest = searchParams.get('isNewsLatest');
  const isKey = searchParams.get('key') || '';

  const { data: news, isLoading: isLoadingNews } = useNews(
    role || '',
    isNewsLatest === 'true',
    isKey
  );

  const renderName = () => {
    if (role === 'CEO') {
      return 'CEO CORNER';
    }
    if (role === 'HRM') {
      return 'HRM INSIGHTS';
    }
    if (role === 'CMO') {
      return 'CMO RADAR';
    }
  };

  return (
    <div style={{ fontFamily: 'GeorgiaPro' }}>
      <div className="bg-white min-h-screen lg:px-8 pt-7 pb-15 max-w-[1512px] mx-auto">
        <div className="hidden lg:flex flex-col gap-2 ">
          <img
            src={ASSETS.icBackGreen}
            alt="icBackGreen"
            className="w-6 h-6 cursor-pointer ml-9"
            onClick={() => navigate(-1)}
          />
          <div className="flex items-end gap-2 justify-between pb-6 border-b border-[#3B3B3B]">
            <span className="text-[#3B3B3B] text-xl uppercase font-normal">
              Tuần san AI
              <br />
              {news?.newNumber}
            </span>
            <img src={ASSETS.icBsm} alt="icBsm" className="h-14" />
            <span className="text-black text-xl uppercase font-normal">
              {renderName()}
            </span>
          </div>
        </div>
        <div className="flex justify-center lg:hidden flex-col gap-2">
          <div className="px-3 flex justify-center">
            <img src={ASSETS.icBsm} alt="icBsm" className="h-14" />
          </div>
          <div className="w-full bg-[#F3F3F3] px-4 py-2 flex items-center justify-between">
            <span className="text-[#3B3B3B]  uppercase font-normal">
              Số thứ nhất
            </span>
            <span className="text-black uppercase font-bold">
              {renderName()}
            </span>
            <span className="text-[#3B3B3B] uppercase font-normal">
              Tuần san AI
            </span>
          </div>
        </div>
        <div className="hidden lg:block text-[#152C92] text-[32px] uppercase text-center pt-[18px] pb-[25px] border-b border-[#3B3B3B] leading-[32px] mb-[25px] font-normal">
          Chinh phục thời đại số với sức mạnh AI - Độc quyền cho lãnh đạo tiên
          phong
        </div>
        {isLoadingNews ? (
          <div className="flex items-center justify-center h-full">
            <CircularProgress />
          </div>
        ) : (
          <div className="px-3 xl:px-12">
            <div className="flex pb-5 lg:mb-5 lg:border-b lg:border-[#A3A3A3] flex-col lg:flex-row">
              <div className="w-full lg:w-[836px] lg:pr-9 flex flex-col gap-5 mb-5 lg:mb-0">
                {news?.contentList
                  ?.filter((_data, index) => index === 0 || index === 1)
                  .map((item, index) => (
                    <div
                      key={`${item.title}-${index}`}
                      className={`${
                        index === 0
                          ? 'pb-5 border-b border-[#A3A3A3]'
                          : 'lg:mt-5 mt-0 border-b border-[#A3A3A3] pb-5 lg:pb-0 lg:border-none'
                      }`}
                    >
                      <div className="w-full">
                        <img src={item.imageUrl} alt={item.title} />
                      </div>
                      <div className="w-full my-5">
                        <span className="text-[#152C92] text-[40px] leading-[40px] font-bold">
                          {item.title}
                        </span>
                      </div>
                      <span className="text-[#3B3B3B] text-xl">
                        {item.content}
                      </span>
                    </div>
                  ))}
              </div>
              <div className="w-full lg:w-[516px] lg:pl-9 lg:border-l lg:border-[#A3A3A3]">
                {news?.contentList
                  ?.filter((_data, index) => index === 2 || index === 3)
                  .map((item, index) => (
                    <div
                      key={`${item.title}-${index}`}
                      className={`${
                        index === 0
                          ? 'pb-5 border-b border-[#A3A3A3] mb-5 lg:mb-0'
                          : 'lg:mt-5 mt-0 border-b border-[#A3A3A3] pb-5 lg:pb-0 lg:border-none'
                      }`}
                    >
                      <div className="w-full">
                        <img src={item.imageUrl} alt={item.title} />
                      </div>
                      <div className="w-full my-5">
                        <span className="text-[#152C92] text-[40px] leading-[40px] font-bold">
                          {item.title}
                        </span>
                      </div>
                      <span className="text-[#3B3B3B] text-xl">
                        {item.content}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
            <div className="flex gap-10">
              {news?.contentList
                ?.filter((_data, index) => index === 4)
                .map((item, index) => (
                  <div key={`${item.title}-${index}`} className="w-full">
                    <div className="w-full">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                    <div className="w-full my-5">
                      <span className="text-[#152C92] text-[40px] leading-[40px] font-bold">
                        {item.title}
                      </span>
                    </div>
                    <span className="text-[#3B3B3B] text-xl">
                      {item.content}
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
      <div className=" w-full h-[100px] bg-[#152C92] flex items-center justify-center lg:gap-20 gap-5">
        <div className="flex items-center justify-center gap-1 lg:gap-3">
          <img
            src={ASSETS.icMailFilled}
            alt="icMailFilled"
            className="w-6 h-6"
          />
          <a href="https://bsmlabs.io" className="!text-white">
            https://bsmlabs.io
          </a>
        </div>
        <div className="flex items-center justify-center gap-1 lg:gap-3">
          <img
            src={ASSETS.icMailFilled}
            alt="icMailFilled"
            className="w-6 h-6"
          />
          <a href="mailto:business@bsmlabs.io" className="!text-white">
            business@bsmlabs.io
          </a>
        </div>
      </div>
    </div>
  );
}

export default NewsScreen;
